import type { FC, ReactNode, RefObject } from 'react';
import { FormProvider as Form, type UseFormReturn } from 'react-hook-form';

type Props = {
  children: ReactNode;
  // biome-ignore lint/suspicious/noExplicitAny: -
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  formRef?: RefObject<HTMLFormElement | null>;
};

export const FormProvider: FC<Props> = ({ children, onSubmit, methods, formRef }) => (
  <Form {...methods}>
    <form ref={formRef} onSubmit={onSubmit}>
      {children}
    </form>
  </Form>
);
